export const SELECT_OPTION_DAYS = [
  { value: 10, label: "Last 10 days", type: "number" },
  { value: 30, label: "Last 30 days", type: "number" },
  { value: 60, label: "Last 60 days", type: "number" },
  { value: 90, label: "Last 90 days", type: "number" },
  // { value: "custom", label: "Custom", type: "date" },
];

export const SELECT_OPTION_YEARS = [
  { value: 2022, label: "2022" },
  { value: 2023, label: "2023" },
  { value: 2024, label: "2024" },
  { value: 2025, label: "2025" },
]; 

export const optionList = [
  { title: "Requested Amount", value: "RequestedAmount" },
  { title: "Net Disbursement Amount", value: "NetDisbursementAmount" },
  { title: "Admin Fees", value: "AdminFees" },
  { title: "Total Applications", value: "TotalApplications" },
  { title: "Total Applicants", value: "TotalApplicants" },
  { title: "New Applicants", value: "NewApplicants" },
];

export const groupedOptions = [
  ["RequestedAmount", "TotalApplications"],
  ["NetDisbursementAmount", "TotalApplicants"],
  ["AdminFees", "NewApplicants"],
];